import { Component } from '@angular/core'

@Component({
  selector: 'kit-antd-upload-example',
  templateUrl: './upload.component.html',
})
export class KitAntdUploadExampleComponent {}
